// La nómina de contratistas y la asignación real.
//
// `assignFinding` reemplaza al par (classification + transición de
// estado) que esta pantalla venía haciendo: el servidor mueve el estado,
// escribe el proveedor y emite el enlace en una sola transacción, y
// reasignar revoca el saliente en esa misma transacción.
import {
  providerCreateResponse,
  providerListResponse,
  findingAssignResponse,
  findingAssignBatchResponse,
  type FindingAssignBatchBody,
  type FindingAssignBatchResponse,
  type FindingAssignBody,
  type FindingAssignResponse,
  type ProviderCreateBody,
  type ProviderCreateResponse,
  type ProviderListResponse,
} from "@bitacorapro/api-types";
import { request } from "../client";

export async function listProviders(): Promise<ProviderListResponse> {
  const json = await request<unknown>("GET", "core", "/providers");
  return providerListResponse.parse(json);
}

export async function createProvider(body: ProviderCreateBody): Promise<ProviderCreateResponse> {
  const json = await request<unknown>("POST", "core", "/providers", { body });
  return providerCreateResponse.parse(json);
}

export async function assignFinding(
  id: string,
  body: FindingAssignBody
): Promise<FindingAssignResponse> {
  const json = await request<unknown>("POST", "core", `/findings/${id}/assign`, { body });
  return findingAssignResponse.parse(json);
}

/** Asignación en lote. El enlace público pertenece a una unidad, así que
 *  la respuesta trae N enlaces para N unidades — nunca uno solo. */
export async function assignFindingBatch(
  body: FindingAssignBatchBody
): Promise<FindingAssignBatchResponse> {
  const json = await request<unknown>("POST", "core", "/findings/assign-batch", { body });
  return findingAssignBatchResponse.parse(json);
}
